/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type ExchangeRequestBody = {
  /**
   * Email address of the enrolled user to mint a per-user key for. Resolved to a user within the authenticated org.
   */
  email: string;
};

/** @internal */
export type ExchangeRequestBody$Outbound = {
  email: string;
};

/** @internal */
export const ExchangeRequestBody$outboundSchema: z.ZodMiniType<
  ExchangeRequestBody$Outbound,
  ExchangeRequestBody
> = z.object({
  email: z.string(),
});

export function exchangeRequestBodyToJSON(
  exchangeRequestBody: ExchangeRequestBody,
): string {
  return JSON.stringify(
    ExchangeRequestBody$outboundSchema.parse(exchangeRequestBody),
  );
}
